import { formValueSelector } from 'redux-form';
import flatMapDeep from 'lodash/flatMapDeep';

// oxlint-disable-next-line no-restricted-imports -- TODO WEBTECH-1501: Replace old schema object types with operation-specific types.

import { SEAT_MAP } from '../../products';
const formSection = SEAT_MAP.name;
const getSeatMap = segments => flatMapDeep(segments, (segment, boundSegmentIndex) => {
  if (!segment || !Object.keys(segment).length) {
    return [];
  }
  const [boundIndex, segmentIndex] = boundSegmentIndex.split('-', 2).map(Number);
  return Object.values(segment).map(value => {
    const {
      carrier,
      column,
      deckType,
      id,
      row,
      seatPreference
    } = value !== null && value !== void 0 ? value : {};
    const {
      code,
      name
    } = carrier !== null && carrier !== void 0 ? carrier : {};
    if (!(row && column) && !seatPreference) {
      return null;
    }
    return {
      boundIndex,
      segmentIndex,
      travelerId: String(id),
      ...(code && name && {
        carrier: {
          code,
          name
        }
      }),
      ...(column && {
        column
      }),
      ...(row && {
        row
      }),
      ...(deckType && {
        deckType
      }),
      ...(seatPreference ? {
        seatPreference
      } : {})
    };
  }).filter(item => item != null);
});
export const getGraphQlSelection = ({
  state,
  form
}) => {
  var _value$value;
  const value = formValueSelector(form)(state, formSection) || {};
  if ((value === null || value === void 0 || (_value$value = value.value) === null || _value$value === void 0 ? void 0 : _value$value.value) !== 'true') {
    return null;
  }
  const selectionSeatMap = getSeatMap(value);
  if (!selectionSeatMap.length) {
    return null;
  }
  return {
    productId: String(SEAT_MAP.id),
    selectionSeatMap
  };
};
//# sourceMappingURL=getGraphQlSelection.js.map